import { render, staticRenderFns } from "./PsikologisDisc.vue?vue&type=template&id=1155eb02"
import script from "./PsikologisDisc.vue?vue&type=script&lang=js"
export * from "./PsikologisDisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports